<template>
  <!-- eslint-disable vue/no-lone-template -->
  <page-wrapper ref="pageEl" title="รายงาน Earn Transfer Home">
    <div ref="page-container" class="page-container row">
      <!-- Loading Section -->
      <LoadingOverlay :active="isLoading" />

      <!-- Report Section -->
      <div class="report-filter col-12">
        <div class="form">
          <div class="section">
            <div>
              <div class="label">วันที่โอนกรรมสิทธิ์</div>
              <date-picker
                v-model="transferDateRange"
                type="daterange"
              ></date-picker>
            </div>
            <div>
              <div class="label">วันที่ได้รับ MNC</div>
              <date-picker
                v-model="receiveMNCDateRange"
                type="daterange"
              ></date-picker>
            </div>
            <div>
              <div class="label">วันที่ Expired</div>
              <date-picker
                v-model="expiredDateRange"
                type="daterange"
              ></date-picker>
            </div>
            <div>
              <div class="label">วันที่ Refund</div>
              <date-picker
                v-model="refundDateRange"
                type="daterange"
              ></date-picker>
            </div>
          </div>

          <div class="section">
            <div>
              <div class="label">โครงการ</div>
              <project-select
                v-model="selectedProject"
                :selected-project-code="selectedProject"
              >
              </project-select>
            </div>
            <div>
              <div class="label">บริษัท</div>
              <el-select
                v-model="selectedCompany"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="(t, idx) in filterCompany"
                  :key="idx"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
            <div>
              <div class="label">Transaction Status</div>
              <el-select
                v-model="selectedTransactionStatus"
                style="width: 100%"
                clearable
                filterable
              >
                <el-option
                  v-for="(t, idx) in filterTransactionStatus"
                  :key="idx"
                  :label="t.label"
                  :value="t.value"
                ></el-option>
              </el-select>
            </div>
          </div>

          <div class="section">
            <div>
              <div class="label">Transaction Type</div>
              <el-checkbox-group
                v-model="selectedTransactionType"
                style="display: flex; flex-direction: column"
              >
                <el-checkbox
                  v-for="(time, idx) in filterTransactionType"
                  :key="idx"
                  :label="time.value"
                  >{{ time.label }}</el-checkbox
                >
              </el-checkbox-group>
            </div>
          </div>

          <div style="display: flex; justify-content: center">
            <el-button type="primary" @click="handleSearch"> ค้นหา </el-button>

            <el-button type="info" @click.prevent="downloadFileReport">
              ดาวน์โหลด
            </el-button>

            <el-button plain type="danger" @click="handleClickClear">
              รีเซ็ต
            </el-button>
          </div>
        </div>
      </div>

      <div class="report-content col-12">
        <div>
          <div v-show="latestUpdateTime" class="report-header">
            <div>
              <b>รายงานอัปเดต</b>
              <p>
                {{ latestUpdateMessage() }}
              </p>
            </div>
            <div>
              <div>
                <p>
                  {{ totalCount(total, limit, reports.length, page) }}
                </p>
              </div>
              <div v-if="total !== 0" align="right">
                <el-button
                  v-for="i in [10, 20, 30]"
                  :key="i"
                  :type="limit == i ? 'primary' : ''"
                  circle
                  size="small"
                  @click="limit = i"
                >
                  {{ i }}
                </el-button>
              </div>
            </div>
          </div>

          <div class="mt-3">
            <DataTable :data="reports" :headers="headers" :loading="isLoading">
              <template slot="editTransactionStatus">
                <el-table-column label="Operation" width="120">
                  <template slot-scope="scope">
                    <span v-if="scope.row.transaction_status !== 'PENDING'"
                      >-</span
                    >
                    <DropdownUpdateEarnReport
                      v-else
                      :id="scope.row.id"
                      :option-list="filterTransactionStatus"
                      :default-value="scope.row.transaction_status"
                      field-name="transaction_status"
                      @onUpdateResult="fetchReports"
                    />
                  </template>
                </el-table-column>
              </template>
            </DataTable>
          </div>

          <div style="text-align: center">
            <el-pagination
              :total="total"
              :current-page="page"
              :page-size="limit"
              background
              layout="
                prev, pager, next
              "
              @current-change="handleCurrentChange"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
  </page-wrapper>
</template>

<script>
import { backendAdminClient } from "@/dependencies"
import { toLocaleTH, validateDateRangeLimit } from "@/lib/dateTime"
import { DateTime } from "luxon"

import DataTable from "@/lib/components/DataTable"
import DatePicker from "@/lib/components/DatePicker"
import LoadingOverlay from "@/lib/components/LoadingOverlay"
import PageWrapper from "@/lib/components/PageWrapper"
import ProjectSelect from "@/lib/components/ProjectSelect"

import DropdownUpdateEarnReport from "../component/DropdownUpdateEarnReport"
import { buildTransferHomeHeaders } from "../presenters/transferHomeHeaders"

export default {
  components: {
    LoadingOverlay,
    PageWrapper,
    DatePicker,
    ProjectSelect,
    DropdownUpdateEarnReport,
    DataTable,
  },
  data() {
    return {
      transferDateRange: [],
      receiveMNCDateRange: [],
      expiredDateRange: [],
      refundDateRange: [],

      filterCompany: [{ label: "ทั้งหมด", value: undefined }],
      filterTransactionStatus: [
        { label: "ทั้งหมด", value: undefined },
        { label: "SUCCESS", value: "SUCCESS" },
        { label: "PENDING", value: "PENDING" },
      ],
      filterTransactionType: [
        { label: "TRANSFER (ปิดโอน)", value: "TRANSFER" },
        {
          label: 'CLAIM (กดรับ Reward "จากการโอนซื้อบ้านใหม่")',
          value: "CLAIM",
        },
        {
          label: "ROLLBACK (ถอยปิดโอน โดยยังไม่กดรับ Reward)",
          value: "ROLLBACK",
        },
        {
          label: "ROLLBACK_REFUND (ถอยปิดโอน โดยมีการกดรับ Reward ไปแล้ว)",
          value: "ROLLBACK_REFUND",
        },
        {
          label: 'EXPIRED (Reward "จากการโอนซื้อบ้านใหม่" หมดอายุ) ',
          value: "EXPIRED",
        },
      ],

      selectedProject: undefined,
      selectedCompany: undefined,
      selectedTransactionStatus: undefined,
      selectedTransactionType: [],

      page: 1,
      limit: 10,
      total: 0,
      latestUpdateTime: null,

      isLoading: true,
      reports: [],
      headers: buildTransferHomeHeaders(this.dateFormat.bind(this)),
    }
  },
  computed: {
    queryParams() {
      const {
        transferDateRange,
        selectedProject: projectCode,
        selectedCompany: companyCode,
        selectedTransactionStatus: transactionStatus,
        selectedTransactionType: transactionType,
        receiveMNCDateRange,
        expiredDateRange,
        refundDateRange,
        page,
        limit,
      } = this.$route.query
      return {
        companyCode,
        transactionStatus,
        transactionType,
        projectCode,
        mncReceivedDate: this.convertDateRange(receiveMNCDateRange),
        refundDate: this.convertDateRange(refundDateRange),
        transferDate: this.convertDateRange(transferDateRange),
        expiredDate: this.convertDateRange(expiredDateRange),
        page: (page && +page) || 1,
        limit: +limit || this.limit,
      }
    },
  },
  watch: {
    "$route.query": async function watchRouteQuery() {
      this.queryBuilder()
      await this.fetchReports()
      this.$refs.pageEl.$el.querySelector(".page-content").scrollTop = 0
    },
    async limit(newLimit, oldLimit) {
      if (newLimit !== oldLimit) {
        await this.handleSearch()
      }
    },
  },
  created() {
    this.fetchSeq = 0
  },
  mounted() {
    this.queryBuilder()
    this.getCompanyCode()
    this.fetchReports()
  },
  methods: {
    totalCount(total, limit, reportsLength, page) {
      if (!total) return "ไม่พบข้อมูล"

      const currentPage = +page || 1
      const isLastPage = limit > reportsLength

      const end = isLastPage ? total : currentPage * limit
      const start = isLastPage
        ? limit * (currentPage - 1) + 1
        : (currentPage - 1) * limit + 1

      return `แสดงผล ${start.toLocaleString()} - ${end.toLocaleString()} จากทั้งหมด ${total.toLocaleString()}`
    },
    queryBuilder() {
      const {
        transferDateRange,
        selectedProject,
        selectedCompany,
        selectedTransactionStatus,
        selectedTransactionType,
        receiveMNCDateRange,
        expiredDateRange,
        refundDateRange,
        page,
        limit,
      } = this.$route.query
      this.selectedProject = selectedProject || null
      this.selectedCompany = selectedCompany || null
      this.selectedTransactionStatus = selectedTransactionStatus || null
      if (selectedTransactionType) {
        this.selectedTransactionType = Array.isArray(selectedTransactionType)
          ? selectedTransactionType
          : [selectedTransactionType]
      } else {
        this.selectedTransactionType = []
      }
      this.transferDateRange = this.setupQueryDateRange(transferDateRange)
      this.receiveMNCDateRange = this.setupQueryDateRange(receiveMNCDateRange)
      this.expiredDateRange = this.setupQueryDateRange(expiredDateRange)
      this.refundDateRange = this.setupQueryDateRange(refundDateRange)
      this.page = (page && +page) || 1
      this.limit = +limit || this.limit
    },
    handleSearch() {
      const projectCode =
        (this.selectedProject && this.selectedProject.projectCode) ||
        this.selectedProject
      const {
        selectedCompany,
        selectedTransactionStatus,
        selectedTransactionType,
        receiveMNCDateRange,
        expiredDateRange,
        refundDateRange,
        transferDateRange,
        limit,
      } = this
      let query = {
        selectedProject: projectCode,
        selectedCompany,
        selectedTransactionStatus,
        selectedTransactionType,
        transferDateRange: this.convertDateRange(transferDateRange),
        receiveMNCDateRange: this.convertDateRange(receiveMNCDateRange),
        expiredDateRange: this.convertDateRange(expiredDateRange),
        refundDateRange: this.convertDateRange(refundDateRange),
        limit,
        page: 1,
      }
      // NOTE: filter out null value
      query = Object.fromEntries(
        Object.entries(query).filter(
          ([, value]) =>
            value !== null &&
            value !== undefined &&
            value !== "" &&
            (!Array.isArray(value) || value.length > 0),
        ),
      )
      // NOTE: replace route with query string
      this.$router.replace({
        name: this.$route.name,
        query,
      })
    },
    setupQueryDateRange(dateRange) {
      if (dateRange && dateRange.length > 1) {
        const [from, to] = dateRange
        return [DateTime.fromISO(from), DateTime.fromISO(to)]
      }
      return []
    },
    convertDateRange(dateRange) {
      if (dateRange && dateRange.length > 1) {
        return dateRange.map((date) => DateTime.fromISO(date).toISO())
      }
      return undefined
    },
    handleClickClear() {
      const route = {
        name: this.$route.name,
      }
      this.$router.replace(route)
    },
    handleCurrentChange(page) {
      const route = {
        name: this.$route.name,
        query: { ...this.$route.query, page: (page && +page) || 1 },
      }
      this.$router.replace(route)
    },
    async fetchReports() {
      // Initial Default
      this.isLoading = true
      this.fetchSeq += 1
      const seq = this.fetchSeq

      try {
        // Query Report
        const { data } = await backendAdminClient.report.getTransferReport(
          this.queryParams,
        )

        // Stale-response guard
        if (seq !== this.fetchSeq) return

        // Validate Response
        if (data) {
          // Get Data
          const { reports, pagination, timestamp } = data.result

          // Set State
          this.reports = reports
          this.latestUpdateTime = timestamp

          // Pagination
          this.total = pagination.total_records
        }
      } catch (error) {
        if (seq !== this.fetchSeq) return
        this.total = 0
        this.reports = []
        this.latestUpdateTime = null
        this.$message.error("ไม่สามารถโหลดข้อมูลรายงานได้")
      } finally {
        if (seq === this.fetchSeq) this.isLoading = false
      }
    },
    async downloadFileReport(event) {
      event.preventDefault()

      try {
        // Get Query
        const query = this.queryParams

        // Validate Report Result
        if (this.reports.length === 0) {
          this.$alert("ไม่พบข้อมูลที่ต้องการดาวน์โหลด", "แจ้งเตือน", {
            confirmButtonText: "ปิด",
            type: "warning",
          })
          return
        }

        // Get Daterange
        const { mncReceivedDate, refundDate, transferDate, expiredDate } = query

        // Validate Daterange
        const dateRange = [
          mncReceivedDate,
          refundDate,
          transferDate,
          expiredDate,
        ].filter((e) => e)

        // Validator
        if (dateRange.length === 0) {
          this.$alert(
            "กรุณาระบุวันที่ได้รับ MNC และระบุช่วงเวลาได้ไม่เกิน 1 เดือน",
            "แจ้งเตือน",
            {
              confirmButtonText: "ปิด",
              type: "warning",
            },
          )
          return
        }

        // Validate Range Limit
        const hasRangeOverLimit = dateRange.some((date) =>
          validateDateRangeLimit(date[0], date[1]),
        )

        // Range Limit Validator
        if (hasRangeOverLimit) {
          this.$alert("ระบุช่วงเวลาได้ไม่เกิน 1 เดือน", "แจ้งเตือน", {
            confirmButtonText: "ปิด",
            type: "warning",
          })
          return
        }

        // Warning Download Message
        await this.$confirm(
          "การดาวน์โหลดจะใช้เวลาดำเนินการสักครู่ กรุณาอย่าออกจากหน้าจอ หรือรีเฟรชหน้า",
          "แจ้งเตือน",
          {
            confirmButtonText: "ดาวน์โหลด",
            cancelButtonText: "ปิด",
            type: "info",
          },
        )

        // Set Loading
        this.isLoading = true

        // Update Download Query
        query.download = true

        // Send Request
        const { data } =
          await backendAdminClient.report.getTransferReport(query)

        // Get Date
        const dateFilename = this.dateFormat(DateTime.utc(), "yyyy-MM-dd-hmmss")

        // Transform Data
        const blob = new Blob([data])

        // Create DOM Element
        const link = document.createElement("a")
        link.href = window.URL.createObjectURL(blob)
        link.download = `${dateFilename}-mnc-transfer-reports.xlsx`

        // Download File
        link.click()

        // Clear Element
        link.remove()
      } catch (error) {
        // user-cancelled $confirm rejects here — no-op
      } finally {
        // Set Un-Loading
        this.isLoading = false
      }
    },
    dateFormat(date, format = "dd/MM/yyyy") {
      const dt = DateTime.isDateTime(date) ? date : DateTime.fromISO(date)
      return toLocaleTH(dt).toFormat(format)
    },
    latestUpdateMessage() {
      if (!this.latestUpdateTime) return ""
      return this.dateFormat(
        this.latestUpdateTime,
        "dd MMMM yyyy เวลา HH:mm น.",
      )
    },
    async getCompanyCode() {
      const initialList = [{ label: "ทั้งหมด", value: undefined }]

      try {
        const { data } = await backendAdminClient.report.getEarnReportCompany()
        const mappingList = data.result.map((item) => ({
          label: item.company_code,
          value: item.company_code,
        }))
        this.filterCompany = initialList.concat(mappingList)
      } catch (error) {
        this.filterCompany = initialList
        this.$message.error("ไม่สามารถโหลดรายชื่อบริษัทได้")
      }
    },
  },
}
</script>

<style lang="scss" scoped>
@import "~@/lib/scss/variables";
.header {
  z-index: 1;
}

.page-container {
  padding: 15px;
}

.report-cell {
  a {
    text-decoration: underline;
  }

  padding: 5px;
  border-left: 1px solid rgb(206, 204, 204);
  border-bottom: 1px solid rgb(228, 225, 225);

  &:empty::before {
    content: "N/A";
    color: #d8d8d8;
  }
}

.page-container {
  padding: 1rem;
  margin: 0;
}

.report-filter {
  width: 100%;
  display: flex;
  gap: 1rem;
  justify-content: center;
}

.report-filter .form {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.form .section {
  display: grid;
  gap: 1rem;
  margin-top: 15px;
  grid-template-columns: repeat(2, 1fr);
}

.form .section[col="3"] {
  grid-template-columns: repeat(3, 1fr);
}

.label {
  font-size: 0.9rem;
  margin-bottom: 0.25rem;
}

.report-content {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.report-content .report-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.el-button.el-button--danger.is-plain:hover,
.el-button.el-button--danger.is-plain:focus {
  color: white !important;
}

@media screen and (max-width: 640px) {
  .form .section,
  .form .section[col="3"] {
    grid-template-columns: 1fr;
  }

  .report-filter {
    margin-bottom: 1rem;
  }
}

.el-input__inner {
  text-align: center;
}

.el-date-editor--daterange,
.el-input__inner {
  width: 100%;
}
</style>
